import React from "react";

const Footer = () => {
  return <div className="footer">Hensel Huang 2025</div>;
};

export default Footer;
